
export interface IAdminAuthRequest {
    password: string;
    offset: number;
}


export class AdminAuthRequest implements IAdminAuthRequest {
    public password: string = '';
    public offset: number = 0;
}


